import React, { useState } from 'react';
import { ChevronLeft } from '@mui/icons-material';
import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Container,
  Breadcrumbs,
  Link,
  MenuList,
  MenuItem,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { LocationType, selectLocationTypes } from '../../store/buyerSlice';

const i18n = {
  title: {
    th: 'ที่ตั้ง',
    en: 'Locations',
    cn: '地点',
  },
};

interface SelectLocationsProps {
  onBackRequest?: () => void;
}

interface SelectLocationsState {
  type: any;
  location: any;
  branch: any;
}

const SelectLocations = (props: SelectLocationsProps) => {
  const [state, setState] = useState<SelectLocationsState>({ type: null, location: null, branch: null });
  const locationTypes = useSelector(selectLocationTypes);

  const renderBreadcrumbs = () => {
    const list = [
      <Link
        color="inherit"
        underline="hover"
        key="type"
        onClick={() => {
          setState({ ...state, type: null, location: null, branch: null });
        }}>
        All
      </Link>,
      // <Link underline="hover" color="inherit" key={}>
      //   Core
      // </Link>,
      // <Typography color="text.primary" key="last">
      //   Breadcrumbs
      // </Typography>
    ];

    if (state.type) {
      if (state.location) {
        list.push(
          <Link underline="hover" color="inherit">
            {state.type.nameTH}
          </Link>,
        );
      } else {
        list.push(
          <Typography color="text.primary" key="last">
            {state.type.nameTH}
          </Typography>,
        );
      }
    }

    return <Breadcrumbs aria-label="breadcrumb">{list}</Breadcrumbs>;
  };

  const handleTypeSelected = (item: LocationType) => {
    setState({ ...state, type: item, location: null, branch: null });
  };

  const renderList = () => {
    let list: JSX.Element[] = [];
    if (!state.type) {
      list = (locationTypes || []).map((item, index) => {
        return (
          <MenuItem key={index} sx={{ borderBottom: '2px solid #f3f3f3' }} onClick={() => handleTypeSelected(item)}>
            {item.nameTH}
          </MenuItem>
        );
      });
    } else if (!state.location) {
      list = (locationTypes || []).map((item, index) => {
        return (
          <MenuItem key={index} sx={{ borderBottom: '2px solid #f3f3f3' }} onClick={() => handleTypeSelected(item)}>
            {item.nameTH}
          </MenuItem>
        );
      });
    }

    return <MenuList sx={{ overflow: 'scroll', background: 'white', padding: '0px' }}>{list}</MenuList>;
  };

  return (
    <Box
      sx={{
        background: '#f3f3f3',
        minHeight: '100vh',
      }}>
      <AppBar elevation={0}>
        <Toolbar sx={{ px: 0 }}>
          <IconButton
            onClick={() => {
              props.onBackRequest?.();
            }}>
            <ChevronLeft fontSize="large" sx={{ color: '#090909' }} />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ textAlign: 'center' }}>
            {i18n.title['th']}
          </Typography>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Container sx={{ paddingY: '15px' }}>
        {renderBreadcrumbs()}
        {renderList()}
      </Container>
    </Box>
  );
};

export default SelectLocations;
